(function ($) {
    'use strict';

    var i18n = (ThemeJS.Variables.Lists && ThemeJS.Variables.Lists.i18n) || {};
    var LAST_LIST_STORAGE_KEY = 'flutterbee_last_add_to_list_id';
    var quantityTimers = {};

    function storeLastListId(listId) {
        listId = listId ? String(listId) : '';
        if (!listId) {
            return;
        }

        try {
            window.localStorage.setItem(LAST_LIST_STORAGE_KEY, listId);
        } catch (e) {
            // Ignore storage failures (private mode, quota, etc.).
        }
    }

    $(document).on('change', '[data-my-lists-quantity] input.qty', function () {
        var $input = $(this);
        var $row = $input.closest('[data-product-row]');
        var $view = $input.closest('[data-my-lists-view]');
        var listId = $view.data('list-id');
        var productId = $row.data('product-row');
        var quantity = parseInt($input.val(), 10) || 1;
        var min = parseInt($input.attr('min'), 10);
        var max = parseInt($input.attr('max'), 10);

        if (!Number.isNaN(min)) {
            quantity = Math.max(min, quantity);
        }

        if (!Number.isNaN(max)) {
            quantity = Math.min(max, quantity);
        }

        $input.val(quantity);
        $row.find('.add_to_cart_button').attr('data-quantity', quantity);

        if (!listId || !productId) {
            return;
        }

        clearTimeout(quantityTimers[productId]);
        quantityTimers[productId] = setTimeout(function () {
            ThemeJS.Functions.send_ajax_request({
                data: {
                    action: 'lists_update_item_quantity',
                    list_id: listId,
                    product_id: productId,
                    quantity: quantity,
                },
                error: function (data) {
                    window.alert(data.message || i18n.quantity_error || 'Unable to update quantity.');
                },
            });
        }, 300);
    });

    $(document).ready(function () {
        $('[data-bs-toggle="tooltip"]').tooltip();
    });
    function setButtonLoading($button, isLoading, loadingText) {
        var $label = $button.find('.my-lists-submit-label, .my-lists-export-label, .my-lists-add-all-label, .my-lists-copy-label, .my-lists-details-label, .my-lists-expand-label').first();
        var $spinner = $button.find('.my-lists-submit-spinner, .my-lists-export-spinner, .my-lists-add-all-spinner, .my-lists-copy-spinner, .my-lists-details-spinner, .my-lists-expand-spinner').first();

        if (!$label.length) {
            $label = $button;
        }

        if (isLoading) {
            $button.prop('disabled', true);
            if (loadingText) {
                $button.data('original-text', $label.text());
                $label.text(loadingText);
            }
            $spinner.prop('hidden', false);
        } else {
            $button.prop('disabled', false);
            if ($button.data('original-text')) {
                $label.text($button.data('original-text'));
            }
            $spinner.prop('hidden', true);
        }
    }

    function showFeedback($el, message, isError) {
        $el.text(message).prop('hidden', false).toggleClass('is-error', !!isError);
    }

    function getShareModal() {
        return document.getElementById('my-lists-share-modal');
    }

    function openShareModal($trigger) {
        var modalEl = getShareModal();
        if (!modalEl) {
            return;
        }

        var listId = $trigger.data('list-id');
        var isPublic = String($trigger.data('is-public')) === '1';
        var shareUrl = $trigger.data('share-url') || '';
        var listTitle = $trigger.data('list-title') || '';

        $(modalEl).find('[data-my-lists-share-list-id]').val(listId);
        $(modalEl).find('[data-my-lists-share-list-name]').text(listTitle);
        $(modalEl).find('[data-my-lists-visibility][value="public"]').prop('checked', isPublic);
        $(modalEl).find('[data-my-lists-visibility][value="private"]').prop('checked', !isPublic);
        $(modalEl).find('[data-my-lists-share-url]').val(shareUrl);
        $(modalEl).find('[data-my-lists-share-url-wrap]').prop('hidden', !isPublic || !shareUrl);
        $(modalEl).find('[data-my-lists-share-feedback]').prop('hidden', true).text('');

        bootstrap.Modal.getOrCreateInstance(modalEl).show();
    }

    function updateShareTrigger($trigger, list) {
        $trigger
            .data('is-public', list.is_public ? '1' : '0')
            .data('share-url', list.share_url || '');
    }

    function applyCartFragments(fragments, cartHash, $button) {
        if (!fragments) {
            return;
        }

        $.each(fragments, function (key, value) {
            $(key).replaceWith(value);
        });

        $(document.body).trigger('added_to_cart', [fragments, cartHash, $button]);
    }

    $(document).on('click', '[data-my-lists-add-all-to-cart]', function () {
        var $button = $(this);
        var $view = $button.closest('[data-my-lists-view]');
        var listId = $view.data('list-id');

        setButtonLoading($button, true, i18n.adding_all || 'Adding...');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_add_all_to_cart',
                list_id: listId,
            },
            success: function (data) {
                applyCartFragments(data.fragments, data.cart_hash, $button);

                if (data.redirect) {
                    window.location.href = data.redirect;
                    return;
                }

                setButtonLoading($button, false);

                if (data.message) {
                    window.alert(data.message);
                }
            },
            error: function (data) {
                setButtonLoading($button, false);
                window.alert(data.message || 'Error');
            },
        });
    });

    $(document).on('click', '[data-my-lists-copy-to-account]', function () {
        var $button = $(this);
        var $view = $button.closest('[data-my-lists-view]');
        var listId = $view.data('list-id');

        setButtonLoading($button, true, i18n.copying || 'Adding...');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_copy_to_account',
                list_id: listId,
            },
            success: function (data) {
                if (data.redirect) {
                    window.location.href = data.redirect;
                    return;
                }

                setButtonLoading($button, false);
            },
            error: function (data) {
                setButtonLoading($button, false);
                window.alert(data.message || 'Error');
            },
        });
    });

    $(document).on('submit', '[data-my-lists-details-form]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $button = $form.find('[data-my-lists-details-submit]');
        var $feedback = $form.find('[data-my-lists-details-feedback]');
        var listId = $form.data('list-id');

        setButtonLoading($button, true, i18n.saving || 'Saving...');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_update_details',
                list_id: listId,
                title: $form.find('[name="title"]').val(),
                comments: $form.find('[name="comments"]').val(),
                po_number: $form.find('[name="po_number"]').val() || '',
                shipping_address_key: $form.find('[name="shipping_address_key"]').val() || '',
                billing_address_key: $form.find('[name="billing_address_key"]').val() || '',
            },
            success: function (data) {
                var list = data.list || {};
                if (list.title) {
                    $form.closest('[data-my-lists-view]').find('.my-lists-account__title').text(list.title);
                    $('[data-my-lists-share][data-list-id="' + listId + '"]').data('list-title', list.title);
                }
                showFeedback($feedback, data.message || i18n.saved || 'Saved.', false);
                setButtonLoading($button, false);
            },
            error: function (data) {
                showFeedback($feedback, data.message || 'Error', true);
                setButtonLoading($button, false);
            },
        });
    });

    $(document).on('click', '[data-my-lists-share]', function () {
        openShareModal($(this));
    });

    $(document).on('change', '[data-my-lists-visibility]', function () {
        var $modal = $(this).closest('.my-lists-share-form');
        var listId = $modal.find('[data-my-lists-share-list-id]').val();
        var isPublic = $modal.find('[data-my-lists-visibility][value="public"]').is(':checked');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_toggle_public',
                list_id: listId,
                is_public: isPublic ? 1 : 0,
            },
            success: function (data) {
                var list = data.list || {};
                $modal.find('[data-my-lists-share-url]').val(list.share_url || '');
                $modal.find('[data-my-lists-share-url-wrap]').prop('hidden', !list.is_public || !list.share_url);
                $('[data-my-lists-share][data-list-id="' + listId + '"]').each(function () {
                    updateShareTrigger($(this), list);
                });
            },
            error: function (data) {
                showFeedback($modal.find('[data-my-lists-share-feedback]'), data.message || 'Error', true);
            },
        });
    });

    $(document).on('click', '[data-my-lists-share-url]', function () {
        var input = this;
        input.select();
        input.setSelectionRange(0, 99999);

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(input.value).then(function () {
                showFeedback($(input).closest('.my-lists-share-form').find('[data-my-lists-share-feedback]'), i18n.copied || 'Copied', false);
            });
            return;
        }

        document.execCommand('copy');
        showFeedback($(input).closest('.my-lists-share-form').find('[data-my-lists-share-feedback]'), i18n.copied || 'Copied', false);
    });

    $(document).on('click', '[data-my-lists-delete]', function () {
        if (!window.confirm(i18n.confirm_delete || 'Delete this list?')) {
            return;
        }

        var $button = $(this);
        var listId = $button.data('list-id');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_delete',
                list_id: listId,
            },
            success: function (data) {
                if (data.redirect) {
                    window.location.href = data.redirect;
                    return;
                }
                $('[data-list-row="' + listId + '"]').remove();
            },
            error: function (data) {
                window.alert(data.message || 'Error');
            },
        });
    });

    $(document).on('click', '[data-my-lists-remove-item]', function () {
        if (!window.confirm(i18n.confirm_remove || 'Remove this item?')) {
            return;
        }

        var $button = $(this);
        var $view = $button.closest('[data-my-lists-view]');
        var listId = $view.data('list-id');
        var productId = $button.data('product-id');

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_remove_item',
                list_id: listId,
                product_id: productId,
            },
            success: function () {
                $('[data-product-row="' + productId + '"]').remove();
                if (!$view.find('[data-product-row]').length) {
                    window.location.reload();
                }
            },
            error: function (data) {
                window.alert(data.message || 'Error');
            },
        });
    });

    $(document).on('click', '[data-my-lists-expand-series]', function () {
        var $button = $(this);
        var $view = $button.closest('[data-my-lists-view]');
        var listId = $view.data('list-id');
        var productId = $button.data('product-id');

        setButtonLoading($button, true);

        ThemeJS.Functions.send_ajax_request({
            data: {
                action: 'lists_expand_series_item',
                list_id: listId,
                product_id: productId,
            },
            success: function (data) {
                if (data.reload) {
                    window.location.reload();
                    return;
                }

                setButtonLoading($button, false);
                if (data.message) {
                    window.alert(data.message);
                }
            },
            error: function (data) {
                setButtonLoading($button, false);
                window.alert(data.message || 'Error');
            },
        });
    });

    $(document).on('click', '[data-my-lists-create]', function () {
        var modalEl = document.getElementById('my-lists-create-modal');
        if (!modalEl) {
            return;
        }

        var $modal = $(modalEl);
        $modal.find('[data-my-lists-create-title]').val('');
        $modal.find('[data-my-lists-create-feedback]').prop('hidden', true).text('');

        bootstrap.Modal.getOrCreateInstance(modalEl).show();
    });

    $(document).on('shown.bs.modal', '#my-lists-create-modal', function () {
        $(this).find('[data-my-lists-create-title]').trigger('focus');
    });

    function createList($form, $button, csv) {
        var $feedback = $form.find('[data-my-lists-create-feedback]');
        var title = $.trim($form.find('[data-my-lists-create-title]').val() || '');
        var data = {
            action: 'lists_create',
            title: title,
        };

        if (typeof csv === 'string') {
            data.csv = csv;
        }

        showFeedback($feedback, '', false);
        $feedback.prop('hidden', true);
        setButtonLoading($button, true, typeof csv === 'string' ? (i18n.importing || 'Importing...') : (i18n.creating || 'Creating...'));
        $form.find('button').prop('disabled', true);

        ThemeJS.Functions.send_ajax_request({
            data: data,
            success: function (data) {
                var list = data.list || {};

                if (list.id) {
                    storeLastListId(list.id);
                }

                if (typeof csv === 'string' && list.list_url) {
                    window.location.href = list.list_url;
                    return;
                }

                window.location.reload();
            },
            error: function (data) {
                showFeedback($feedback, data.message || 'Error', true);
                setButtonLoading($button, false);
                $form.find('button').prop('disabled', false);
            },
        });
    }

    function validateCreateTitle($form) {
        var title = $.trim($form.find('[data-my-lists-create-title]').val() || '');

        if (!title) {
            showFeedback($form.find('[data-my-lists-create-feedback]'), i18n.enter_list_name || 'Enter a list name.', true);
            return false;
        }

        return true;
    }

    $(document).on('submit', '[data-my-lists-create-form]', function (event) {
        event.preventDefault();

        var $form = $(this);

        if (!validateCreateTitle($form)) {
            return;
        }

        createList($form, $form.find('[data-my-lists-create-submit]'));
    });

    $(document).on('click', '[data-my-lists-create-import]', function () {
        var $form = $(this).closest('[data-my-lists-create-form]');

        if (!validateCreateTitle($form)) {
            return;
        }

        $form.find('[data-my-lists-create-feedback]').prop('hidden', true).text('');
        $form.find('[data-my-lists-create-import-input]').trigger('click');
    });

    $(document).on('change', '[data-my-lists-create-import-input]', function () {
        var $form = $(this).closest('[data-my-lists-create-form]');
        var $feedback = $form.find('[data-my-lists-create-feedback]');
        var file = this.files && this.files[0];

        this.value = '';

        if (!file) {
            return;
        }

        if (!/\.csv$/i.test(file.name)) {
            showFeedback($feedback, i18n.import_invalid_file || 'Please upload a .csv file.', true);
            return;
        }

        var reader = new FileReader();

        reader.onload = function () {
            createList($form, $form.find('[data-my-lists-create-import]'), String(reader.result || ''));
        };

        reader.onerror = function () {
            showFeedback($feedback, i18n.import_error || 'Unable to import ISBNs.', true);
        };

        reader.readAsText(file);
    });

    $(document).on('submit', '[data-my-lists-export-form]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var $button = $form.find('[data-my-lists-export-submit]');
        var fields = $form.find('input[name="fields[]"]:checked').map(function () {
            return $(this).val();
        }).get();

        if (!fields.length) {
            showFeedback($form.find('[data-my-lists-export-feedback]'), 'Select at least one column.', true);
            return;
        }

        var listId = $form.data('list-id');
        var payload = {
            action: 'lists_export',
            list_id: listId,
            fields: fields,
        };
        var $details = $('[data-my-lists-details-form][data-list-id="' + listId + '"]');

        if ($details.length) {
            ['title', 'comments', 'po_number', 'shipping_address_key', 'billing_address_key'].forEach(function (name) {
                var $field = $details.find('[name="' + name + '"]');
                if ($field.length) {
                    payload[name] = $field.val() || '';
                }
            });
        }

        setButtonLoading($button, true);

        ThemeJS.Functions.send_ajax_request({
            data: payload,
            success: function (data) {
                var url = ThemeJS.Variables.Ajax.url +
                    '?action=lists_download' +
                    '&token=' + encodeURIComponent(data.download_token) +
                    '&nonce=' + encodeURIComponent(ThemeJS.Variables.Ajax.nonce);
                window.location.href = url;
                setButtonLoading($button, false);
            },
            error: function (data) {
                showFeedback($form.find('[data-my-lists-export-feedback]'), data.message || 'Error', true);
                setButtonLoading($button, false);
            },
        });
    });

    $(document).on('click', '[data-my-lists-import-toggle]', function () {
        var $button = $(this);
        var $panel = $('#' + $button.attr('aria-controls'));
        var isOpen = $panel.prop('hidden');

        $panel.prop('hidden', !isOpen);
        $button.attr('aria-expanded', isOpen ? 'true' : 'false').toggleClass('is-active', isOpen);
    });

    function importIsbnsFile($panel, file) {
        var $error = $panel.find('[data-my-lists-import-error]');
        var $status = $panel.find('[data-my-lists-import-status]');

        $error.prop('hidden', true).text('');

        if (!file || !/\.csv$/i.test(file.name)) {
            $error.text(i18n.import_invalid_file || 'Please upload a .csv file.').prop('hidden', false);
            return;
        }

        if ($panel.hasClass('is-loading')) {
            return;
        }

        var reader = new FileReader();

        reader.onload = function () {
            ThemeJS.Functions.send_ajax_request({
                data: {
                    action: 'lists_import_isbns',
                    list_id: $panel.data('list-id'),
                    csv: String(reader.result || ''),
                },
                success: function () {
                    window.location.reload();
                },
                error: function (data) {
                    $panel.removeClass('is-loading');
                    $status.prop('hidden', true);
                    $error.text(data.message || i18n.import_error || 'Unable to import ISBNs.').prop('hidden', false);
                },
            });
        };

        reader.onerror = function () {
            $panel.removeClass('is-loading');
            $status.prop('hidden', true);
            $error.text(i18n.import_error || 'Unable to import ISBNs.').prop('hidden', false);
        };

        $panel.addClass('is-loading');
        $status.prop('hidden', false);
        reader.readAsText(file);
    }

    $(document).on('change', '[data-my-lists-import-input]', function () {
        importIsbnsFile($(this).closest('[data-my-lists-import]'), this.files && this.files[0]);
        this.value = '';
    });

    $(document).on('dragenter dragover', '[data-my-lists-import-dropzone]', function (event) {
        event.preventDefault();
        $(this).addClass('is-dragover');
    });

    $(document).on('dragleave dragend', '[data-my-lists-import-dropzone]', function (event) {
        if (!this.contains(event.relatedTarget)) {
            $(this).removeClass('is-dragover');
        }
    });

    $(document).on('drop', '[data-my-lists-import-dropzone]', function (event) {
        event.preventDefault();
        $(this).removeClass('is-dragover');

        var files = event.originalEvent.dataTransfer && event.originalEvent.dataTransfer.files;
        importIsbnsFile($(this).closest('[data-my-lists-import]'), files && files[0]);
    });

    $(function () {
        var modalEl = document.querySelector('[data-my-lists-import-unmatched]');
        if (modalEl && typeof bootstrap !== 'undefined') {
            bootstrap.Modal.getOrCreateInstance(modalEl).show();
        }
    });
})(jQuery);
